import { QuestionsAndAnswer } from '@components/question-and-answer/types';
import { Collapse, CollapseProps } from 'antd';
import { FC, useState } from 'react';
import styles from './question-and-answer.module.scss';

const { Panel } = Collapse;

interface QuestionAndAnswerCollapseProps {
  questionsAndAnswers?: QuestionsAndAnswer[];
}

export const QuestionAndAnswerCollapse: FC<QuestionAndAnswerCollapseProps> = ({
  questionsAndAnswers,
}) => {
  const [activeKey, setActiveKey] = useState<CollapseProps['activeKey']>(undefined);

  return !!questionsAndAnswers?.length ? (
    <Collapse className={styles.collapse} accordion activeKey={activeKey} onChange={setActiveKey}>
      {questionsAndAnswers.map((qA, index) => (
        <Panel
          header={<div tabIndex={0}>{qA.question}</div>}
          key={qA.key}
          className={styles.answer}
        >
          <p>{qA.answer}</p>
          {qA?.additionalContent}
        </Panel>
      ))}
    </Collapse>
  ) : (
    <></>
  );
};
